import { render, staticRenderFns } from "./TopFansPage.vue?vue&type=template&id=6179991a&scoped=true&"
import script from "./TopFansPage.vue?vue&type=script&lang=js&"
export * from "./TopFansPage.vue?vue&type=script&lang=js&"
import style0 from "./TopFansPage.vue?vue&type=style&index=0&id=6179991a&lang=scss&scoped=true&"
import style1 from "./TopFansPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6179991a",
  null
  
)

export default component.exports